import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const FeatureContext = createContext({});

const FeatureProvider = props => {
  const [enabledFeatures, setEnabledFeatures] = useState({});

  useEffect(() => {
    // Vite requires static env var access - can't use dynamic keys
    setEnabledFeatures({
      FLAG_PROFILE: import.meta.env.VITE_FEATURE_FLAG_PROFILE === 'true',
      MUTE_PROFILE: import.meta.env.VITE_FEATURE_MUTE_PROFILE === 'true',
      FLAG_CONTRIBUTION: import.meta.env.VITE_FEATURE_FLAG_CONTRIBUTION === 'true',
      NOTIFICATIONS: import.meta.env.VITE_FEATURE_NOTIFICATIONS === 'true',
      ALERTS: import.meta.env.VITE_FEATURE_ALERTS === 'true',
    });
  }, []);

  const featureEnabled = useCallback(feature => enabledFeatures[feature], [enabledFeatures]);

  const setFeatureEnabled = useCallback((feature, value) => {
    setEnabledFeatures(prevState => ({
      ...prevState,
      [feature]: value,
    }));
  }, []);

  const value = useMemo(
    () => ({
      features: {
        flagProfile: 'FLAG_PROFILE',
        muteProfile: 'MUTE_PROFILE',
        flagContribution: 'FLAG_CONTRIBUTION',
        notifications: 'NOTIFICATIONS',
        alerts: 'ALERTS',
      },
      featureEnabled,
      setFeatureEnabled,
    }),
    [featureEnabled, setFeatureEnabled],
  );

  return <FeatureContext.Provider value={value} {...props} />;
};

const useFeatures = () => useContext(FeatureContext);

export { FeatureProvider, useFeatures };
